// src/utils/shareApp.js
import { getShareUrl } from "../config/links";
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";

// Partage le lien du support Muhasaba (Google Play si dispo, sinon fallback)
export async function shareMuhasabaApp(language = "fr") {
  const url = getShareUrl();

  const title = language === "fr" ? "Support Muhasaba" : "Muhasaba Support";
  const text =
    language === "fr"
      ? "Je te partage ce support de Muhasaba (gratuit) :"
      : "Sharing this Muhasaba support (free):";

  // ✅ 0) Priorité : Capacitor Share si on est dans l'app Android/iOS
  try {
    if (Capacitor?.isNativePlatform?.()) {
      await Share.share({
        title,
        text,
        url,
        dialogTitle: language === "fr" ? "Partager" : "Share",
      });
      return { ok: true, method: "capacitor" };
    }
  } catch (e) {
    // si l'utilisateur annule (selon Android), on ignore
    return { ok: false, aborted: true, method: "capacitor" };
  }

  // 1) Web Share API (mobile web / PWA)
  try {
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ title, text, url });
      return { ok: true, method: "share" };
    }
  } catch (e) {
    if (e?.name === "AbortError") return { ok: false, aborted: true, method: "share" };
    // sinon on continue vers fallback
  }

  // 2) Clipboard fallback (desktop)
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return { ok: true, method: "clipboard" };
    }
  } catch {}

  // 3) Dernier recours (prompt)
  try {
    window.prompt(language === "fr" ? "Copie ce lien :" : "Copy this link:", url);
    return { ok: true, method: "prompt" };
  } catch {
    return { ok: false, method: "none" };
  }
}
